import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Console } from 'console';
import autoTable from 'jspdf-autotable';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { FutureGuidesSchoolVO } from 'src/app/shared/models/FutureGuidesSchoolVO';
import { GuidesResponseVO } from 'src/app/shared/models/GuidesResponseVO';
import { LstStoreResponse } from 'src/app/shared/models/lstStoreResponse';
import { PeriodsVO } from 'src/app/shared/models/PeriodsVO';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { Store } from 'src/app/shared/models/Store';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { WrksParcipResVO } from 'src/app/shared/models/WrksParcipResVO';
import { WrksResponseVO } from 'src/app/shared/models/WrksResponseVO';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import * as FileSaver from 'file-saver';
import { IndexType } from 'typescript';
import { SchoolFpgDataVO } from 'src/app/shared/models/SchoolFPGDataVO';
import { AuthenticationService } from 'src/app/_services';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';

@Component({
  selector: 'app-epg-list',
  templateUrl: './epg-list.component.html',
  styleUrls: ['./epg-list.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class EpgListComponent implements OnInit {
  //Elementos de traducción inicio.
  lstRespTranslate: TranslateRelLabelVO[];

  translations: Record<string, string> = {};
  // translations.lbl_zone: string = "zone_";
  // translations.lbl_natio: string = "national_";
  // translations.lbl_local: string = "local_";
  // translations.lbl_period: string = "period_";
  // translations.lbl_select: string = "select_";
  // translations.lbl_search: string = "search_";
  // translations.lbl_participants: string = "participants_";
  // translations.lbl_name: string = "name_";
  // translations.lbl_lastName: string = "last_name_";
  // translations.lbl_Contact: string = "contact_";
  // translations.lbl_stage: string = "stage_";
  // translations.lbl_startDate: string = "starting_date_";
  // translations.lbl_workshop: string = "workshop_";
  // translations.lbl_supervised: string = "supervised_";
  // translations.lbl_total: string = "total_";
  // translations.lbl_there_are: string = "there_are_";
  // translations.lbl_go_Back: string = "back_";
  // translations.lbl_list: string = "list_";
  // translations.lbl_sch_for_prepar_guid: string = "sch_for_prepar_guid_";
  // translations.lbl_loading: string = "loading_";
  // translations.lbl_status: string = "status_";
  // translations.lbl_number: string = "number_";
  // translations.lbl_future_guide: string = "future_guide_";
  // translations.lbl_guide: string = "guide_";
  // translations.lbl_contact: string = "contact_";
  // translations.lbl_email: string = "email_";
  // translations.lbl_showing: string = "showing_";
  // translations.lbl_of: string = "of_";
  // translations.lbl_records: string = "records_";
  // translations.lbl_year: string = "year_";
  // translations.lbl_no_valid : string = "is_not_valid_";
  // translations.lbl_no_records_found : string = "no_records_found_";






  //Elementos de traducción fin
  //Elementos de seguridad inicio
  token: string;
  currentUser: any;
  security: SecurityDocument;
  //Elementos de seguridad fin

  lstSchoolsFpg: SchoolFpgDataVO[];
  listSchoolStatus: any[];
  selectedSchoolStatus: any;

  lstGui: GuidesResponseVO[];
  lstWrks: WrksResponseVO[];
  lstPartServ: WrksParcipResVO[]
  listStores: string[] = [];

  listPeriods: PeriodsVO[];
  selectedPeriod: PeriodsVO;



  listZones: Store[];
  selectedZone: Store;
  listNatio: Store[];
  selectedNatio: Store;
  listLocal: Store[];
  selectedLocal: Store;
  blocked: boolean = true;

  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService,
    private translationService: TovpilLanguageService,
    private authenticationService: AuthenticationService,
    private filesService: TovpilFilesService) { }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(
        params => {
          this.token = params.token;
        });

    if (this.token) {
    } else {
      this.currentUser = this.authenticationService.currentUserValue;
    }


    this.getSecurity();

  }
  search() {
    this.lstSchoolsFpg = [];
    this.getValidStores();
  }

  getValidPeriods() {
    this.blocked = true;
    this.apiService.getValidPeriods(this.security.language).then(
      data => {
        this.listPeriods = data;
        this.selectedPeriod = this.listPeriods[0];

        this.findSupStoreRelationship();
       
      }).finally(() => {
        //this.search();
        setTimeout(() => {
          this.blocked = false;
        }, 1500)
      });
  }

  getValidStores() {
    let lstRes: LstStoreResponse;
    let supStoreId: string;
    if (this.selectedLocal != null && this.selectedLocal.storeId != null) {
      supStoreId = this.selectedLocal.storeId;
    } else if (this.selectedNatio != null && this.selectedNatio.storeId != null) {
      supStoreId = this.selectedNatio.storeId;
    } else if (this.selectedZone != null && this.selectedZone.storeId != null) {
      supStoreId = this.selectedZone.storeId;
    } else {
      supStoreId = "0000000002";
    }

    this.getAllSchoolFpg(supStoreId);
  }

  getSecurity() {
    this.listZones = [];
    this.listNatio = [];
    this.listLocal = [];
    //.
    this.apiService.findSecurityById({
      "id": this.token != null ? this.token : this.currentUser.tokenProfile
    }).then(data => {
      this.security = data;
      this.getTranslatedLabels();

      this.listCategorySchoolStatus();
    });
  }


  async getTranslatedLabels() {
    try {
      await this.translationService.getTranslatedLabels(this.security.language, this.security.region);
      this.translations = this.translationService.getLabels();
      // this.failedMsg = this.translations.translations.lbl_internal_server_error;
      // await this.getLanguages();
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}`});
      // Error al traer labels traducidos
    }
  }

  // getTranslatedLabels() {
  //   let map = new Map();
  //   let lstCat: CategoryLan[];

  //   this.apiService.listByLanguageMultFields(
  //     {
  //       'language': this.security.language,
  //       'region': this.security.region,
  //       'lstLabels': [this.translations.lbl_no_valid, this.translations.lbl_no_records_found,this.translations.lbl_select, this.translations.lbl_zone, this.translations.lbl_name, this.translations.lbl_natio, this.translations.lbl_local, this.translations.lbl_period, this.translations.lbl_lastName, this.translations.lbl_participants, this.translations.lbl_Contact, this.translations.lbl_stage, this.translations.lbl_startDate, this.translations.lbl_workshop, this.translations.lbl_supervised, this.translations.lbl_search, this.translations.lbl_total, this.translations.lbl_there_are, this.translations.lbl_go_Back, this.translations.lbl_list, this.translations.lbl_sch_for_prepar_guid, this.translations.lbl_loading, this.translations.lbl_status, this.translations.lbl_number, this.translations.lbl_future_guide, this.translations.lbl_guide, this.translations.lbl_contact, this.translations.lbl_email, this.translations.lbl_showing, this.translations.lbl_of, this.translations.lbl_records, this.translations.lbl_year]
  //     }
  //   ).then(
  //     trDocs => {
  //       this.lstRespTranslate = trDocs;

  //       trDocs.forEach((element) => {
  //         map.set(element.labelId, element.translation);
  //       });
  //       this.translations.lbl_select = map.get(this.translations.lbl_select);
  //       this.translations.lbl_lastName = map.get(this.translations.lbl_lastName);
  //       this.translations.lbl_name = map.get(this.translations.lbl_name);
  //       this.translations.lbl_local = map.get(this.translations.lbl_local);
  //       this.translations.lbl_natio = map.get(this.translations.lbl_natio);
  //       this.translations.lbl_zone = map.get(this.translations.lbl_zone);

  //       this.translations.lbl_participants = map.get(this.translations.lbl_participants);
  //       this.translations.lbl_search = map.get(this.translations.lbl_search);
  //       this.translations.lbl_period = map.get(this.translations.lbl_period);

  //       this.translations.lbl_Contact = map.get(this.translations.lbl_Contact);
  //       this.translations.lbl_stage = map.get(this.translations.lbl_stage);
  //       this.translations.lbl_startDate = map.get(this.translations.lbl_startDate);
  //       this.translations.lbl_supervised = map.get(this.translations.lbl_supervised);
  //       this.translations.lbl_workshop = map.get(this.translations.lbl_workshop);
  //       this.translations.lbl_total = map.get(this.translations.lbl_total);
  //       this.translations.lbl_there_are = map.get(this.translations.lbl_there_are);
  //       this.translations.lbl_go_Back = map.get(this.translations.lbl_go_Back);
  //       this.translations.lbl_list = map.get(this.translations.lbl_list);
  //       this.translations.lbl_sch_for_prepar_guid = map.get(this.translations.lbl_sch_for_prepar_guid);
  //       this.translations.lbl_loading = map.get(this.translations.lbl_loading);
  //       this.translations.lbl_status = map.get(this.translations.lbl_status);
  //       this.translations.lbl_number = map.get(this.translations.lbl_number);
  //       this.translations.lbl_future_guide = map.get(this.translations.lbl_future_guide);
  //       this.translations.lbl_guide = map.get(this.translations.lbl_guide);
  //       this.translations.lbl_contact = map.get(this.translations.lbl_contact);
  //       this.translations.lbl_email = map.get(this.translations.lbl_email);
  //       this.translations.lbl_showing = map.get(this.translations.lbl_showing);
  //       this.translations.lbl_of = map.get(this.translations.lbl_of);
  //       this.translations.lbl_records = map.get(this.translations.lbl_records);
  //       this.translations.lbl_year = map.get(this.translations.lbl_year);
  //       this.translations.lbl_no_valid = map.get(this.translations.lbl_no_valid);
  //       this.translations.lbl_no_records_found = map.get(this.translations.lbl_no_records_found);


  //     });

  // }

  getChildStores(selStr: string, level: string) {
    let res: LstStoreResponse;
    this.apiService.getListStore(selStr, this.selectedPeriod.year, this.selectedPeriod.period).then(
      data => {
        res = data;
        if (level == 'L') {
          this.listLocal = res.lstStore;
        } else if (level == 'N') {
          this.listNatio = res.lstStore;
        } else if (level == 'Z') {
          if (this.listZones == null || this.listZones.length == 0) {
            this.listZones = res.lstStore;
          }
        }
      });

  }

  loadLocals(event) {

    if (this.selectedNatio != null && this.selectedNatio.storeId != null) {
      this.getChildStores(this.selectedNatio.storeId, 'L');
    }
  }
  loadNatios(event) {
    if (this.selectedZone != null && this.selectedZone.storeId != null) {
      this.getChildStores(this.selectedZone.storeId, 'N');
    }
  }


  exportExcel() {
    if (this.lstSchoolsFpg === null) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translations.lbl_no_records_found,
        life: 3000
      });
    } else if (this.lstSchoolsFpg.length < 1) {
      this.messageService.add({
        severity: 'warn',
        summary: `${this.translations.lbl_list} ${this.translations.lbl_no_valid}`,
        life: 3000
      });
    } else {
      const filteredJSON = this.lstSchoolsFpg.map((item) => {
        return {
          "ALIAS": item ? (item?.schoolFPG?.name || 'S/N') : 'S/N',
          "ESTATUS": item ? (this.verifyStatus(item?.wrks01, item?.wrks02, item?.wrks03) || 'S/N') : 'S/N',
          "NUM_FG": item ? (item?.enrollNum || 'S/N') : 'S/N',
          "IMPARTIDOR": item ? (item?.guideName || 'S/N') : 'S/N',
          "CONTACTO": item?.wrks01 ? (item?.wrks01?.gui?.email || 'S/N') : 'S/N',
          "ETAPA": item ? (item?.wrks01?.wst?.wsShrName || 'S/N') : 'S/N',
          "LOCAL": item ? (item?.storeName || 'S/N') : 'S/N',
        };
      });


      this.filesService.tovpilExportXLSX(filteredJSON, 'listEpg_');

    }
  }



  exportPdf() {
    if (this.lstSchoolsFpg === null) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translations.lbl_no_records_found,
        life: 3000
      });
    } else if (this.lstSchoolsFpg.length < 1) {
      this.messageService.add({
        severity: 'warn',
        summary: `${this.translations.lbl_list} ${this.translations.lbl_no_valid}`,
        life: 3000
      });
    } else {
      const filteredJSON = this.lstSchoolsFpg.map((item) => {
        return {
          "ALIAS": item ? (item?.schoolFPG?.name || 'S/N') : 'S/N',
          "ESTATUS": item ? (this.verifyStatus(item?.wrks01, item?.wrks02, item?.wrks03) || 'S/N') : 'S/N',
          "NUM_FG": item ? (item?.enrollNum || 'S/N') : 'S/N',
          "IMPARTIDOR": item ? (item?.guideName || 'S/N') : 'S/N',
          "CONTACTO": item?.wrks01 ? (item?.wrks01?.gui?.email || 'S/N') : 'S/N',
          "ETAPA": item ? (item?.wrks01?.wst?.wsShrName || 'S/N') : 'S/N',
          "LOCAL": item ? (item?.storeName || 'S/N') : 'S/N',
        };
      });



      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listEpg_');

    }
  }




  /**
 * The function retrieves workshop guides based on the guide ID using an API service in TypeScript.
 */
  getAllSchoolFpg(supStoreId: any) {
    this.blocked = true;    
    this.apiService.getAllSchoolFpg({
      // PENDIENTE FALLA SI SE AGREGA PERO APARECE EN REQUEST
      "storeId": supStoreId,
      "status":this.selectedSchoolStatus.valueId
    }).then(
      data => {
        const tempLst = data;
        this.lstSchoolsFpg = tempLst.filter(rec => (rec.schoolFPG.status == this.selectedSchoolStatus.valueId));
      }).finally(() => {
        setTimeout(() => {
          this.blocked = false;
        }, 1500);
      });
  }

  goBack() {
    window.close();
  }

  verifyStatus(wrks01: any, wrks02: any, wrks03: any) {
    const getStatus = (wrks: any) => wrks && wrks.f0 && wrks.f0.status;

    if (getStatus(wrks01) === "A") return "I";
    if (getStatus(wrks02) === "A") return "II";
    if (getStatus(wrks03) === "A") return "III";

    return "S/N";
  }
  listCategorySchoolStatus() {    
    this.apiService.listCategoryTranslation({
      "fieldId": "schoolStat",
      "language": this.security.language
    }).then(
      data => {
        this.listSchoolStatus = data
        this.selectedSchoolStatus = this.listSchoolStatus.filter(rec => (rec.valueId == "A"));
        if(!this.selectedSchoolStatus || !this.selectedSchoolStatus.valueId){
          this.selectedSchoolStatus=this.listSchoolStatus[2];
        }
        this.getValidPeriods();
      })
  }
  async findSupStoreRelationship() {
    await this.apiService.findSupStoreRelationship({
      "storeId": this.security.storeId
    }).then(
      data => {
        if (data) {
          this.selectedLocal = data.strLocal;
          this.selectedNatio = data.strNatio;
          this.selectedZone = data.strZone;

          if (this.security.levelId == 'L') {
            this.listZones.push(this.selectedZone);
            this.listNatio.push(this.selectedNatio);
            this.listLocal.push(this.selectedLocal);
          } else if (this.security.levelId == 'N') {
            this.listZones.push(this.selectedZone);
            this.listNatio.push(this.selectedNatio);
            this.getChildStores(this.selectedNatio.storeId, 'L');
          } else if (this.security.levelId == 'Z') {
            this.listZones.push(this.selectedZone);
            this.getChildStores(this.selectedZone.storeId, 'N');
          } else if (this.security.levelId == 'I') {
            this.getChildStores('0000000002', 'Z');
          } else {
          }
        }
      })
  }
}
